export function formatToRands (value) {
  var valueWithoutDecimalsAsString = parseInt(value || 0) + ''
  var formattedValue = ''
  if (value < 1000) {
    return `R ${valueWithoutDecimalsAsString}`
  }

  const lastLetterIndex = valueWithoutDecimalsAsString.length - 1
  var powersOfTen = 0
  for (let i = lastLetterIndex; i >= 0; i--) {
    if (powersOfTen++ === 3) {
      formattedValue = ' ' + formattedValue
      powersOfTen = 1
    }
    formattedValue = valueWithoutDecimalsAsString[i] + formattedValue
  }

  return `R ${formattedValue}`
}

export function formatToRandsWithoutSymbol (value) {
  var valueWithoutDecimalsAsString = parseInt(value || 0) + ''
  var formattedValue = ''
  if (value < 1000) {
    return `${valueWithoutDecimalsAsString}`
  }

  const lastLetterIndex = valueWithoutDecimalsAsString.length - 1
  var powersOfTen = 0
  for (let i = lastLetterIndex; i >= 0; i--) {
    if (powersOfTen++ === 3) {
      formattedValue = ' ' + formattedValue
      powersOfTen = 1
    }
    formattedValue = valueWithoutDecimalsAsString[i] + formattedValue
  }

  return `${formattedValue}`
}

export function inputFormatToRands (value) {
  if (value == null || isNaN(value)) {
    return ''
  }

  return `${value.toLocaleString('en-za')}`
}
